module.exports = __webpack_public_path__ + "static/img/file.a523680.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Ad/file.png
// module id = 557
// module chunks = 143